import {createSvgIcon} from '../create-svg-icon';

export const ArrowBackIosIcon = createSvgIcon(
  <path d="M17.51 3.87 15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" />
, 'ArrowBackIosOutlined');
